import i18next from "i18next";
import { IoReturnDownBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

import { checkIsAllowedRefundRequest } from "../../../utils";

import { RefundButton } from "./style";

// Кнопка «Возврат» в списке заказов: ведёт на страницу заявки с уже заполненным номером заказа.
// Показывается только для выписанных заказов (ticketingDone / success); клик не открывает страницу заказа.
const OrderRefundLink = ({ orderId, sessionId, bookingStatus, orderStatus, fullWidth = false }) => {
  const { t } = i18next;
  const navigate = useNavigate();

  if (!checkIsAllowedRefundRequest(bookingStatus, orderStatus)) return null;

  const handleClick = e => {
    e.stopPropagation();
    const session = sessionId ? `&session=${encodeURIComponent(sessionId)}` : "";
    navigate(`/refund-request?order_id=${encodeURIComponent(orderId)}${session}`);
  };

  return (
    <RefundButton type="button" onClick={handleClick} style={fullWidth ? { width: "100%" } : undefined}>
      <IoReturnDownBack />
      {t("refund_button_title")}
    </RefundButton>
  );
};

export default OrderRefundLink;
